import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import style from './AppVersion.module.css';
import imgComplete from '../../../../images/common/i_complete.svg';


const AppVersion = () => {

    const navigate = useNavigate();

    const [currentVersion, setCurrentVersion] = useState('');
    const [latestVersion, setLatestVersion] = useState('');
    const [loading, setLoading] = useState(true);

    const isLatest = currentVersion && latestVersion && currentVersion === latestVersion;

    useEffect(() => {
        const handleMessage = (e) => {
            try {
                const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
                if (data.type === 'APP_VERSION_INFO') {
                    setCurrentVersion(data.currentVersion);
                    setLatestVersion(data.latestVersion);
                    setLoading(false);
                }
            } catch (err) { }
        };

        window.addEventListener('message', handleMessage);

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'REQUEST_APP_VERSION'
            }));
        }

        return () => window.removeEventListener('message', handleMessage);
    }, []);

    const handleUpdate = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: window.nativeAppPlatform?.isIOS
                    ? 'https://apps.apple.com/kr/app/%EC%BC%80%EC%96%B4%ED%94%8C%EB%9F%AC%EC%8A%A4/id6754904057'
                    : 'https://play.google.com/store/apps/details?id=com.cmcnu.careplus'
            }));
        }
    };

    const handleBack = () => {
        navigate(URL.APP_SETTINGS, { replace: true });
    };

    if (!window.ReactNativeWebView) {
        return (
            <>
                <HeadSub title="앱 버전 정보" onBack={handleBack} />
                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">
                        <p>앱에서만 확인 가능합니다.</p>
                    </div>
                </div>
            </>
        );
    }

    if (loading) {
        return (
            <>
                <HeadSub title="앱 버전 정보" onBack={handleBack} />
                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">
                        <p>버전 정보를 불러오는 중...</p>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <HeadSub title="앱 버전 정보" onBack={handleBack} />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">

                    <div className={style['mid-box']}>

                        <div className={style['content-box']}>
                            <div className={style['top']} data-version={isLatest ? undefined : 'old'}>
                                <span>v{currentVersion}</span>
                            </div>
                            <div className={style['botm']}>
                                {isLatest ? (
                                    <p>현재 버전이 최신 버전입니다</p>
                                ) : (
                                    <>
                                        <p>현재 버전이 최신 버전이 아닙니다</p>
                                        <span>원활한 서비스 이용을 위해 <br />
                                            지금 바로 <b>앱을 업데이트</b> 해주세요!
                                        </span>
                                        <strong>최신버전 v{latestVersion}</strong>
                                    </>
                                )}
                            </div>
                        </div>

                        {!isLatest && (
                            <div className='btn-box'>
                                <button
                                    className='btn'
                                    data-btn-type="fill-main"
                                    data-btn-size='md'
                                    onClick={handleUpdate}
                                >
                                    <span>최신 버전으로 업데이트</span>
                                </button>
                            </div>
                        )}

                    </div>

                </div>
            </div>
        </>
    );
};

export default AppVersion;